import { type CodeSystem } from '@heidi/coding/contracts';
import type { components } from '@heidi/schema/ml-scribe';

export type SessionClinicalEntity = components['schemas']['CodedClinicalEntity'];
export type EmMdmResult = components['schemas']['EmMdmResponse'];
export type EmAvailableCode = components['schemas']['EmCodeOption'];

export enum EmbeddingsScreen {
  EmbeddingsList = 'EmbeddingsList',
  AddingCode = 'AddingCode',
  ReplacingCode = 'ReplacingCode',
  CodeDetail = 'CodeDetail',
  CodeDetailFromSearch = 'CodeDetailFromSearch',
  CodeDetailFromReplace = 'CodeDetailFromReplace',
  EmLevelDeterminator = 'EmLevelDeterminator',
  EmCodeDetail = 'EmCodeDetail',
}

export interface EmbeddingsPanelProps {
  sessionId: string;
  /** Resolved by the app mount. The package does not read the flag. */
  isSnomedUkGpEnabled: boolean;
  /**
   * When true, drops the hardcoded 380px width and lets the parent
   * constrain the panel. Opt-in for V2 surfaces (e.g. the V2 Suggested
   * card detail view) where the panel renders inside a narrower slot.
   * Default `false` preserves the V1 side-panel layout.
   */
  embeddedInCard?: boolean;
}

export interface EmbeddingItemProps {
  code: SessionClinicalEntity;
  onCodeClick?: (code: SessionClinicalEntity) => void;
  onCopyCode?: (code: SessionClinicalEntity) => boolean | void | Promise<boolean | void>;
  onInfoButtonClick?: (code: SessionClinicalEntity) => void;
  onUnlinkButtonClick?: (code: SessionClinicalEntity) => void;
  onReplaceButtonClick?: (code: SessionClinicalEntity) => void;
  onViewEvidenceButtonClick?: (code: SessionClinicalEntity) => void;
}

export interface CodeSystemSelectProps {
  isSelected: boolean;
  setSelectedCode: (code: CodeSystem | 'All') => void;
  code: CodeSystem | 'All';
  label: string;
}
